import React, { useEffect, useState } from 'react';
import { Modal, message, Typography } from 'antd';
import EditRealmForm from './EditRealmForm';
import RealmsService from '../services/RealmService'; // Update the path if needed
import { useRealmContext } from '../contexts/RealmProvider';
import { useAuthContext } from '../contexts/AuthProvider';
import ApiCaller from '../services/ApiCaller'; // Assuming this is a shared utility
import PortalConfiguration from '../configuration/config'; // Update the path if needed
import CustomSpinner from './CustomSpinner';
import './css/EditRealmModal.css';
import ExportRealmButton from './ExportRealmButton'; // Assuming this is a shared component

const EditRealmModal = ({ visible, onClose, realmTypes }) => {
  const { realmID } = useRealmContext();
  const { sessionID } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [realmData, setRealmData] = useState(null);
  const { Title, Text } = Typography;

  const realmServiceAPICaller = new ApiCaller(PortalConfiguration.realmsServiceURL);

  // Fetch realm data on open
  useEffect(() => {
    const fetchRealm = async () => {
      setLoading(true);
      try {
        const result = await RealmsService.getRealm(realmServiceAPICaller, sessionID, realmID);
        setRealmData(result);
      } catch (error) {
        console.error("Error fetching realm data:", error);
        message.error("Failed to load realm data.");
        onClose();
      } finally {
        setLoading(false);
      }
    };

    if (visible && realmID) {
      fetchRealm();
    }
  }, [visible, realmID, sessionID, onClose]);

  const handleSubmit = async (formValues) => {
    try {
      const updatedRealm = {
        PK_RealmId: formValues.realmId,
        SK_Type: formValues.type,
        payload: {
          description: formValues.description,
          notes: formValues.notes || [],
        },
        created: realmData?.created || new Date().toISOString(),
        updated: new Date().toISOString()
      };
      await RealmsService.updateRealm(realmServiceAPICaller, sessionID, realmData.SK_Type, updatedRealm);
      message.success('Realm updated successfully!');
      onClose();
    } catch (err) {
      message.error('Update failed. Check logs for details.');
    }
  };

  return (
    <Modal
      title={<Title level={3} className='custom-title'>Edit Realm Details</Title>}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      className={`edit-realm-modal ${loading ? 'no-scroll' : ''}`}
    >
      {realmData ? (
        <>
            <EditRealmForm
              realm={realmData}
              onSubmit={handleSubmit}
              onCancel={onClose}
              realmTypes={realmTypes}
            />
            
        </>
      ) : (
        <CustomSpinner />
      )}
    </Modal>
  );
};

export default EditRealmModal;
